import { SignupData, OTPData, ApiResponse, Customer } from '../types';

// Base API configuration
// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api';

// Generic API call helper
// const apiCall = async <T>(
//   endpoint: string,
//   options: RequestInit = {}
// ): Promise<ApiResponse<T>> => {
//   try {
//     const response = await fetch(`${API_BASE_URL}${endpoint}`, {
//       headers: {
//         'Content-Type': 'application/json',
//         ...options.headers,
//       },
//       ...options,
//     });
//
//     const data = await response.json();
//
//     if (!response.ok) {
//       throw new Error(data.message || 'API request failed');
//     }
//
//     return data;
//   } catch (error) {
//     console.error('API Error:', error);
//     return {
//       success: false,
//       error: error instanceof Error ? error.message : 'Unknown error occurred'
//     };
//   }
// };

/**
 * Submit customer signup data and trigger SMS OTP
 * 
 * INTEGRATION POINT: Connect this to your backend endpoint
 * Expected backend endpoint: POST /api/signup
 * Expected request body: { fullName: string, phoneNumber: string }
 * Expected response: { success: boolean, message?: string, data?: { customerId: string } }
 */
export const submitSignup = async (signupData: SignupData): Promise<ApiResponse<{ customerId: string }>> => {
  // Simulate API delay for demo purposes
  await new Promise(resolve => setTimeout(resolve, 2000));
  
  // TODO: Replace this mock implementation with actual API call
  // return apiCall<{ customerId: string }>('/signup', {
  //   method: 'POST',
  //   body: JSON.stringify(signupData),
  // });

  // Mock success response - remove this when connecting to real backend
  console.log('Mock API: Submitting signup data:', signupData);
  
  // Simulate occasional errors for testing
  if (Math.random() < 0.1) {
    return {
      success: false,
      error: 'Phone number already registered. Please try a different number.'
    };
  }

  return {
    success: true,
    message: 'OTP sent successfully to your phone',
    data: { customerId: 'mock-customer-id-' + Date.now() }
  };
};

/**
 * Verify SMS OTP code
 * 
 * INTEGRATION POINT: Connect this to your backend endpoint
 * Expected backend endpoint: POST /api/verify-otp
 * Expected request body: { phoneNumber: string, otp: string }
 * Expected response: { success: boolean, message?: string, data?: Customer }
 */
export const verifyOTP = async (otpData: OTPData): Promise<ApiResponse<Customer>> => {
  // Simulate API delay for demo purposes
  await new Promise(resolve => setTimeout(resolve, 1500));
  
  // TODO: Replace this mock implementation with actual API call
  // return apiCall<Customer>('/verify-otp', {
  //   method: 'POST',
  //   body: JSON.stringify(otpData),
  // });

  // Mock success response - remove this when connecting to real backend
  console.log('Mock API: Verifying OTP:', otpData);
  
  // Simple mock validation (accept any 6-digit code except 000000)
  if (otpData.otp === '000000') {
    return {
      success: false,
      error: 'Invalid OTP code. Please check your messages and try again.'
    };
  }

  if (otpData.otp.length !== 6 || !/^\d+$/.test(otpData.otp)) {
    return {
      success: false,
      error: 'OTP must be a 6-digit number.'
    };
  }

  return {
    success: true,
    message: 'Phone number verified successfully!',
    data: {
      id: 'mock-customer-' + Date.now(),
      fullName: 'Customer Name', // In real implementation, this comes from the backend
      phoneNumber: otpData.phoneNumber,
      isVerified: true,
      createdAt: new Date().toISOString()
    }
  };
};

/**
 * Resend OTP code
 * 
 * INTEGRATION POINT: Connect this to your backend endpoint
 * Expected backend endpoint: POST /api/resend-otp
 * Expected request body: { phoneNumber: string }
 * Expected response: { success: boolean, message?: string }
 */
export const resendOTP = async (phoneNumber: string): Promise<ApiResponse> => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  // TODO: Replace this mock implementation with actual API call
  // return apiCall('/resend-otp', {
  //   method: 'POST',
  //   body: JSON.stringify({ phoneNumber }),
  // });

  console.log('Mock API: Resending OTP to:', phoneNumber);
  
  return {
    success: true,
    message: 'New OTP sent to your phone'
  };
};
